import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";

interface Props {
  open: boolean;
  onClose: () => void;
  onSave: (name: string) => Promise<void> | void;
  loading: boolean;
}

export default function CreateStationDialog({
  open,
  onClose,
  onSave,
  loading,
}: Props) {
  const [name, setName] = useState("");
  const [error, setError] = useState("");

  const inputRef = useRef<HTMLInputElement>(null);

  // === Enfocar y limpiar al abrir ===
  useEffect(() => {
    if (open) {
      setName("");
      setError("");
      setTimeout(() => inputRef.current?.focus(), 50);
    }
  }, [open]);

  const handleSave = async () => {
    if (!name.trim()) {
      setError("El nombre es obligatorio");
      return;
    }

    await onSave(name.trim().toUpperCase());
    setName("");
    setError("");
  };

  const handleEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSave();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Nueva pantalla</DialogTitle>

      <DialogContent>
        <TextField
          inputRef={inputRef}
          margin="normal"
          label="Nombre de la pantalla"
          fullWidth
          value={name}
          onChange={(e) => {
            setName(e.target.value.toUpperCase());
            if (error) setError("");
          }}
          onKeyDown={handleEnter}
          error={!!error}
          helperText={error}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={handleSave} variant="contained" loading={loading}>
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
